/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".airport-webcams__table-header[_ngcontent-%COMP%]{font-family:Roboto,sans-serif;font-size:13px;font-weight:700;background:#dbf6fb;padding:14px 30px;border-top:1px solid #cee5e9}.airport-webcams__disclaimers[_ngcontent-%COMP%]{font-size:13px;color:#666}#addWebcam[_ngcontent-%COMP%]{background-color:#00b6ac}"];
export { styles as styles };
